<!--<ng-progress color="red" [thick]="true" [showSpinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'"></ng-progress>-->
<!--<div class="subBlockContainer" id="return-search">-->
<!--  <div class="subBlockContent">-->
<!--    <child-header [title]="title" (closeEvent)="close()"></child-header>-->
<!--    <div class="mat-toolbar-menu">-->
<!--    </div>-->
<!--    <div class="subBlockContent">-->
<!--      <div class="inner-subBlock-wrapper">-->
<!--        <div class="page-title-wrapper">-->

<!--          <div id="return-desc" class="mb-4">-->
<!--            Please enter the invoice number that you wish to return, and provide some details to assist us in processing your request-->
<!--          </div>-->

<!--          <div class="filter-wrapper">-->
<!--            <div class="searchInputGroup">-->
<!--              <div class="searchIcon">-->
<!--                <img src="../images/site-icons/search-red.svg">-->
<!--&lt;!&ndash;                <img src="../images/new_ui/filter.png">&ndash;&gt;-->
<!--              </div>-->
<!--              <input class="searchInput" type="text" placeholder="Search Invoice Number" onfocus="this.placeholder=''"-->
<!--                onblur="this.placeholder='Search Invoice Orders'"  [formControl]="searchControl">-->
<!--            </div>-->
<!--          </div>-->


<!--          <div class="shared-outer-wrapper table-header-allign" style="margin-top: 20px">-->
<!--            <table matSort (matSortChange)="sortData($event)" class="white">-->
<!--              <thead>-->
<!--                <tr class="row">-->
<!--                  <th style="width: 50%; padding-left: 15px;" mat-sort-header="invoiveNo">INVOICE NO</th>-->
<!--                  <th style="width: 15%" mat-sort-header="invoiceDate">INVOICE DATE</th>-->
<!--                  <th style="width: 15%" mat-sort-header="resellerPO">RESELLER PO</th>-->
<!--                  <th style="width: 10%" mat-sort-header="totalEx">TOTAL EX</th>-->
<!--                  <th style="width: 10%"></th>-->
<!--                </tr>-->
<!--              </thead>-->
<!--            </table>-->
<!--          </div>-->
<!--          <div class="shared-outer-wrapper child-body">-->
<!--            &lt;!&ndash;  &ndash;&gt;-->
<!--            <table matSort (matSortChange)="sortData($event)" class="white">-->
<!--              <thead hidden="true">-->
<!--                <tr class="row">-->
<!--                  <th style="width: 50%; padding-left: 15px;" mat-sort-header="invoiveNo">INVOICE NO</th>-->
<!--                  <th style="width: 15%" mat-sort-header="invoiceDate">INVOICE DATE</th>-->
<!--                  <th style="width: 15%" mat-sort-header="resellerPO">RESELLER PO</th>-->
<!--                  <th style="width: 10%" mat-sort-header="totalEx">TOTAL EX</th>-->
<!--                  <th style="width: 10%"></th>-->
<!--                </tr>-->
<!--              </thead>-->
<!--              <tbody>-->
<!--                <ng-container *ngFor="let order of sortedData">-->
<!--                  <tr class="row inforow">-->
<!--                    <td style="width: 50%;padding-left: 15px;">{{order?.orderNo}}{{order?.orderSuffix}}</td>-->
<!--                    <td style="width: 15%">{{order?.dateInvoiced.split("-").join("/")}}</td>-->
<!--                    <td style="width: 15%">{{order?.resellerPO}}</td>-->
<!--                    <td class="align-right" style="width: 10%; padding-right: 38px;">-->
<!--                      {{convertTotal(order?.totalEx)}}</td>-->
<!--                    &lt;!&ndash; <td class="align-right" style="width: 10%; padding-right: 38px;">-->
<!--                       {{order?.totalEx | currency:'AUD':'symbol-narrow':'.2-2'}}</td> &ndash;&gt;-->
<!--                    <td class="button-wrapper" style="width:10%;">-->
<!--                      <a [routerLink]="[order.orderNo,order.orderSuffix]"-->
<!--                        class="red-link">Select</a>-->
<!--                    </td>-->
<!--                    <div class="row middlerow">-->
<!--                      <span class="font-col-secondary" *ngIf="order?.courier">COURIER:&nbsp;</span>-->
<!--                      <span class="font-col-primary">{{order?.courier}}</span>-->
<!--                      <span class="divider-wrapper" *ngIf="order?.connote">&nbsp;&nbsp;|&nbsp;&nbsp;</span>-->
<!--                      <span class="font-col-secondary" *ngIf="order?.connote">CONNOTE:&nbsp;</span>-->
<!--                      <div class="font-col-primary" [innerHTML]="order?.connote"></div>-->
<!--                    </div>-->
<!--                    <div class="row downloadrow">-->
<!--                      <td class="downloadtextcol">Download Documents:</td>-->
<!--                      <td class="shippeddownloadiconcol">-->
<!--                        <a [href]="order?.orderConfirmationUrl" target="_blank" *ngIf="order?.orderConfirmationUrl"-->
<!--                          style="display: inline-block;">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/order-confirmation-grey.png" placement="bottom"-->
<!--                ngbTooltip="Order Confirmation"> &ndash;&gt;-->
<!--                          <span class="basic-icon orderConfirm-icon" placement="bottom"-->
<!--                            ngbTooltip="Order Confirmation"></span>-->
<!--                        </a>-->
<!--                        <a [href]="order?.creditNoteUrl" target="_blank" *ngIf="order?.creditNoteUrl">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/credit-note-grey.png" placement="bottom"-->
<!--                ngbTooltip="Credit Note"> &ndash;&gt;-->
<!--                          <span class="basic-icon creditNote-icon" placement="bottom" ngbTooltip="Credit Note"></span>-->
<!--                        </a>-->

<!--                        <a [href]="order?.deliveryDocketUrl" target="_blank" *ngIf="order?.deliveryDocketUrl">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/delivery-docket-grey.png" placement="bottom"-->
<!--                ngbTooltip="Delivery Docket"> &ndash;&gt;-->
<!--                          <span class="basic-icon deliveryDocket-icon" placement="bottom"-->
<!--                            ngbTooltip="Delivery Docket"></span>-->
<!--                        </a>-->

<!--                        <a [href]="order?.invoiceUrl" target="_blank" *ngIf="order?.invoiceUrl">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/tax-invoice-grey.png" placement="bottom"-->
<!--                ngbTooltip="Tax Invoice"> &ndash;&gt;-->
<!--                          <span class="basic-icon taxInvoice-icon" placement="bottom" ngbTooltip="Tax Invoice"></span>-->
<!--                        </a>-->
<!--                        <a [href]="order?.licenceAgreeUrl" target="_blank" *ngIf="order?.licenceAgreeUrl">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/license-agreement-grey.png" placement="bottom"-->
<!--                ngbTooltip="License Agreement"> &ndash;&gt;-->
<!--                          <span class="basic-icon licenseAgreement-icon" placement="bottom"-->
<!--                            ngbTooltip="License Agreement"></span>-->
<!--                        </a>-->
<!--                        <a [href]="order?.orderAmendUrl" target="_blank" *ngIf="order?.orderAmendUrl">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/amendment-grey.png" placement="bottom"-->
<!--                ngbTooltip="Amendment"> &ndash;&gt;-->
<!--                          <span class="basic-icon amendment-icon" placement="bottom" ngbTooltip="Amendment"></span>-->
<!--                        </a>-->
<!--                        <a [href]="order?.podUrl" target="_blank" *ngIf="order?.podUrl">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/proof-delivery-grey.png" placement="bottom"-->
<!--                ngbTooltip="Proof of Delivery"> &ndash;&gt;-->
<!--                          <span class="basic-icon proofOfDelivery-icon" placement="bottom"-->
<!--                            ngbTooltip="Proof of Delivery"></span>-->
<!--                        </a>-->
<!--                        <a [href]="order?.rmaUrl" target="_blank" *ngIf="order?.rmaUrl">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/return-authority-grey.png" placement="bottom"-->
<!--                ngbTooltip="Return Authority"> &ndash;&gt;-->
<!--                          <span class="basic-icon returnAuthority-icon" placement="bottom"-->
<!--                            ngbTooltip="Return Authority"></span>-->
<!--                        </a>-->
<!--                        <a [href]="order?.resellerPOUrl" target="_blank" *ngIf="order?.resellerPOUrl">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/purchase-order-grey.png" placement="bottom"-->
<!--                ngbTooltip="Purchase Order"> &ndash;&gt;-->
<!--                          <span class="basic-icon purchaseOrder-icon" placement="bottom"-->
<!--                            ngbTooltip="Purchase Order"></span>-->
<!--                        </a>-->
<!--                        <a [href]="order?.supportConUrl" target="_blank" *ngIf="order?.supportConUrl">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/support-agreement-grey.png" placement="bottom"-->
<!--                ngbTooltip="Support Agreement"> &ndash;&gt;-->
<!--                          <span class="basic-icon supportAgreement-icon" placement="bottom"-->
<!--                            ngbTooltip="Support Agreement"></span>-->
<!--                        </a>-->
<!--                        <a *ngIf="order?.hasSerials ==='1'" target="_blank"-->
<!--                          (click)="exportOrderSerials(order?.orderNo, order?.orderSuffix)">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/support-agreement-grey.png" placement="bottom"-->
<!--                ngbTooltip="Support Agreement"> &ndash;&gt;-->
<!--                          <span class="basic-icon orderSerials-icon" placement="bottom"-->
<!--                            ngbTooltip="Export Serials"></span>-->
<!--                        </a>-->
<!--                        <a [href]="order?.autopilotUrl" target="_blank" *ngIf="order?.autopilotUrl">-->
<!--                          &lt;!&ndash; <img src="../images/new_ui/open-orders/credit-note-grey.png" placement="bottom"-->
<!--                ngbTooltip="Credit Note"> &ndash;&gt;-->
<!--                          <span class="basic-icon autopilot-icon" placement="bottom" ngbTooltip="Autopilot"></span>-->
<!--                        </a>-->
<!--                      </td>-->
<!--                    </div>-->
<!--                  </tr>-->
<!--                </ng-container>-->
<!--              </tbody>-->
<!--            </table>-->
<!--          </div>-->

<!--        </div>-->
<!--      </div>-->
<!--      <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">-->
<!--      </loading-screen>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<!--<router-outlet></router-outlet>-->


<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'"></ng-progress>

<div class="subBlockContainer" id="return-search">

  <div class="subBlockContent" *ngIf="!narrow">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="mat-toolbar-menu">
    </div>
    <div class="subBlockContent">
      <div class="inner-subBlock-wrapper">
        <div class="page-title-wrapper">

          <div id="return-desc" class="mb-4">
            Please enter the invoice number that you wish to return, and provide some details to assist us in processing
            your request
          </div>

          <div class="filter-wrapper">
            <div class="searchInputGroup">
              <div class="searchIcon">
                <img src="../images/site-icons/search-red.svg">
                <!--                <img src="../images/new_ui/filter.png">-->
              </div>
              <input class="searchInput" type="text" placeholder="Search Invoice Number" onfocus="this.placeholder=''"
                     onblur="this.placeholder='Search Invoice Orders'" [formControl]="searchControl">
            </div>
          </div>


          <ng-container *ngIf="hasEmptyFilterResult">
            <div style="margin-top: 20px;" class="noResult-wrapper">
              <div><img src="../images/new_ui/no-found.png"></div>
              <div>No results found</div>
              <div>Sorry, that filter combination has no results.<br>Please try different criteria.</div>
              <div>
                <button (click)="filterReset()" class="button button-red button-large">Try again</button>
              </div>
              <div class="noResult-feedback">Send Feedback</div>
            </div>
          </ng-container>

          <ng-container *ngIf="!hasEmptyFilterResult && sortedData">
            <div class="shared-outer-wrapper table-header-allign" style="margin-top: 20px">
              <table matSort (matSortChange)="sortData($event)" class="white">
                <thead>
                <tr class="row">
                  <th style="width: 50%; padding-left: 15px;" mat-sort-header="invoiveNo">INVOICE NO</th>
                  <th style="width: 15%" mat-sort-header="invoiceDate">INVOICE DATE</th>
                  <th style="width: 15%" mat-sort-header="resellerPO">RESELLER PO</th>
                  <th style="width: 10%" mat-sort-header="totalEx">TOTAL EX</th>
                  <th style="width: 10%"></th>
                </tr>
                </thead>
              </table>
            </div>
            <div class="shared-outer-wrapper child-body">
              <!--  -->
              <table matSort (matSortChange)="sortData($event)" class="white">
                <thead hidden="true">
                <tr class="row">
                  <th style="width: 50%; padding-left: 15px;" mat-sort-header="invoiveNo">INVOICE NO</th>
                  <th style="width: 15%" mat-sort-header="invoiceDate">INVOICE DATE</th>
                  <th style="width: 15%" mat-sort-header="resellerPO">RESELLER PO</th>
                  <th style="width: 10%" mat-sort-header="totalEx">TOTAL EX</th>
                  <th style="width: 10%"></th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let order of sortedData">
                  <tr class="row inforow">
                    <td style="width: 50%;padding-left: 15px;">{{order?.orderNo}}{{order?.orderSuffix}}</td>
                    <td style="width: 15%">{{order?.dateInvoiced.split("-").join("/")}}</td>
                    <td style="width: 15%">{{order?.resellerPO}}</td>
                    <td class="align-right" style="width: 10%; padding-right: 38px;">
                      {{convertTotal(order?.totalEx)}}</td>
                    <!-- <td class="align-right" style="width: 10%; padding-right: 38px;">
                       {{order?.totalEx | currency:'AUD':'symbol-narrow':'.2-2'}}</td> -->
                    <!--                  [routerLink]="[order.orderNo,order.orderSuffix]"-->
                    <td class="button-wrapper" style="width:10%;">
                    <span class="return-link" (click)="goReturnsDetail(order)"
                          [class.active]="selectedOrder == order.orderNo+'-'+order.orderSuffix"
                    >Select</span>
                    </td>
                    <div class="row middlerow">
                      <span class="font-col-secondary" *ngIf="order?.courier">COURIER:&nbsp;</span>
                      <span class="font-col-primary">{{order?.courier}}</span>
                      <span class="divider-wrapper" *ngIf="order?.connote">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                      <span class="font-col-secondary" *ngIf="order?.connote">CONNOTE:&nbsp;</span>
                      <div class="font-col-primary" [innerHTML]="order?.connote"></div>
                    </div>
                    <div class="row downloadrow">
                      <td class="downloadtextcol">Download Documents:</td>
                      <td class="shippeddownloadiconcol">
                        <a [href]="order?.orderConfirmationUrl" target="_blank" *ngIf="order?.orderConfirmationUrl"
                           style="display: inline-block;">
                          <!-- <img src="../images/new_ui/open-orders/order-confirmation-grey.png" placement="bottom"
                ngbTooltip="Order Confirmation"> -->
                          <span class="basic-icon orderConfirm-icon" placement="bottom"
                                ngbTooltip="Order Confirmation"></span>
                        </a>
                        <a [href]="order?.creditNoteUrl" target="_blank" *ngIf="order?.creditNoteUrl">
                          <!-- <img src="../images/new_ui/open-orders/credit-note-grey.png" placement="bottom"
                ngbTooltip="Credit Note"> -->
                          <span class="basic-icon creditNote-icon" placement="bottom" ngbTooltip="Credit Note"></span>
                        </a>

                        <a [href]="order?.deliveryDocketUrl" target="_blank" *ngIf="order?.deliveryDocketUrl">
                          <!-- <img src="../images/new_ui/open-orders/delivery-docket-grey.png" placement="bottom"
                ngbTooltip="Delivery Docket"> -->
                          <span class="basic-icon deliveryDocket-icon" placement="bottom"
                                ngbTooltip="Delivery Docket"></span>
                        </a>

                        <a [href]="order?.invoiceUrl" target="_blank" *ngIf="order?.invoiceUrl">
                          <!-- <img src="../images/new_ui/open-orders/tax-invoice-grey.png" placement="bottom"
                ngbTooltip="Tax Invoice"> -->
                          <span class="basic-icon taxInvoice-icon" placement="bottom" ngbTooltip="Tax Invoice"></span>
                        </a>
                        <a [href]="order?.licenceAgreeUrl" target="_blank" *ngIf="order?.licenceAgreeUrl">
                          <!-- <img src="../images/new_ui/open-orders/license-agreement-grey.png" placement="bottom"
                ngbTooltip="License Agreement"> -->
                          <span class="basic-icon licenseAgreement-icon" placement="bottom"
                                ngbTooltip="License Agreement"></span>
                        </a>
                        <a [href]="order?.orderAmendUrl" target="_blank" *ngIf="order?.orderAmendUrl">
                          <!-- <img src="../images/new_ui/open-orders/amendment-grey.png" placement="bottom"
                ngbTooltip="Amendment"> -->
                          <span class="basic-icon amendment-icon" placement="bottom" ngbTooltip="Amendment"></span>
                        </a>
                        <a [href]="order?.podUrl" target="_blank" *ngIf="order?.podUrl">
                          <!-- <img src="../images/new_ui/open-orders/proof-delivery-grey.png" placement="bottom"
                ngbTooltip="Proof of Delivery"> -->
                          <span class="basic-icon proofOfDelivery-icon" placement="bottom"
                                ngbTooltip="Proof of Delivery"></span>
                        </a>
                        <a [href]="order?.rmaUrl" target="_blank" *ngIf="order?.rmaUrl">
                          <!-- <img src="../images/new_ui/open-orders/return-authority-grey.png" placement="bottom"
                ngbTooltip="Return Authority"> -->
                          <span class="basic-icon returnAuthority-icon" placement="bottom"
                                ngbTooltip="Return Authority"></span>
                        </a>
                        <a [href]="order?.resellerPOUrl" target="_blank" *ngIf="order?.resellerPOUrl">
                          <!-- <img src="../images/new_ui/open-orders/purchase-order-grey.png" placement="bottom"
                ngbTooltip="Purchase Order"> -->
                          <span class="basic-icon purchaseOrder-icon" placement="bottom"
                                ngbTooltip="Purchase Order"></span>
                        </a>
                        <a [href]="order?.supportConUrl" target="_blank" *ngIf="order?.supportConUrl">
                          <!-- <img src="../images/new_ui/open-orders/support-agreement-grey.png" placement="bottom"
                ngbTooltip="Support Agreement"> -->
                          <span class="basic-icon supportAgreement-icon" placement="bottom"
                                ngbTooltip="Support Agreement"></span>
                        </a>
                        <a *ngIf="order?.hasSerials ==='1'" target="_blank"
                           (click)="exportOrderSerials(order?.orderNo, order?.orderSuffix)">
                          <!-- <img src="../images/new_ui/open-orders/support-agreement-grey.png" placement="bottom"
                ngbTooltip="Support Agreement"> -->
                          <span class="basic-icon orderSerials-icon" placement="bottom"
                                ngbTooltip="Export Serials"></span>
                        </a>
                        <a [href]="order?.autopilotUrl" target="_blank" *ngIf="order?.autopilotUrl">
                          <!-- <img src="../images/new_ui/open-orders/credit-note-grey.png" placement="bottom"
                ngbTooltip="Credit Note"> -->
                          <span class="basic-icon autopilot-icon" placement="bottom" ngbTooltip="Autopilot"></span>
                        </a>
                      </td>
                    </div>
                  </tr>
                </ng-container>
                </tbody>
              </table>
            </div>
          </ng-container>
        </div>
      </div>
      <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
      </loading-screen>
    </div>
  </div>


  <div class="blockContainer narrow-sidebar narrow-sidebar-overflow" id="levelTwo"
       *ngIf="narrow">

    <div class="combination-loader">

      <div class="child-sidebar sidebar-loader">
        <child-header [title]="title" (closeEvent)="close()"></child-header>

        <div class="child-body renewal-list-mini">
          <div class="searchInputGroup">
            <div class="searchIcon search-carts">
              <img src="../images/site-icons/search-red.svg">
            </div>
            <input class="searchInput searchInputGroup-small" type="text"
                   placeholder="Search Invoice Number" onfocus="this.placeholder=''"
                   onblur="this.placeholder='Search Invoice Orders'" [formControl]="searchControl">
          </div>

          <ng-container *ngFor="let order of sortedData;index as i">
            <!--            [class.active]="selectedSerial == item.out_serial"-->
            <div class="menu-wrapper menu-wrapper-position"
                 (click)="goReturnsDetail(order)"
                 [class.active]="selectedOrder == order.orderNo+'-'+order.orderSuffix"
            >
              <div class="total-div">
                <div class="narrow-title truncate">
                  {{order?.orderNo}}{{order?.orderSuffix}}
                </div>
                <span class="narrow-text">
                                     Date:{{order?.dateInvoiced.split("-").join("/")}}
                  | Total:{{convertTotal(order?.totalEx)}}
                                  </span><br>

                <!-- <span class="narrow-text">
                {{item.out_opportunity_id}}</span> -->
              </div>
            </div>

          </ng-container>

          <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
          </loading-screen>

        </div>
      </div>

      <div class="child-loader">
        <router-outlet></router-outlet>
      </div>

    </div>

  </div>

</div>
